import { arrayOf, bool, func, number, shape } from 'prop-types';
import React from 'react';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import TaskStatus, { TASK_STATUSES } from '../../generic/TaskStatus';
import {
  bookingEntryShape,
  campaignShape,
  detailedInvoiceShape,
  opportunityShape,
  productShape,
  taskShape,
} from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import InvoiceModalContent from './InvoiceModalContent';

class BalanceModalContent extends React.Component {
  componentDidMount() {
    const { onInitialize, opportunity } = this.props;

    onInitialize({
      opportunityId: opportunity.id,
      latestTask: opportunity.latestTask,
    });
  }

  handleUpdateTaskStatus = task => {
    this.props.onUpdateLatestTask(task);

    if (task.status === TASK_STATUSES.SUCCESS) {
      this.props.onReloadBookingEntries(this.props.opportunity.id);
    }
  };

  render() {
    const { toggle, latestTask } = this.props;
    return (
      <>
        <ModalHeader tag="h3" toggle={toggle} className="w-100">
          Balance
        </ModalHeader>
        <ModalBody>
          <InvoiceModalContent {...this.props} />
        </ModalBody>
        {latestTask && (
          <ModalFooter className="small">
            <TaskStatus
              task={latestTask}
              taskName="Generation of booking entries"
              onUpdateTaskStatus={this.handleUpdateTaskStatus}
            />
          </ModalFooter>
        )}
      </>
    );
  }
}

BalanceModalContent.propTypes = {
  opportunity: opportunityShape.isRequired,
  toggle: func.isRequired,
  bookingEntries: arrayOf(bookingEntryShape.isRequired).isRequired,
  invoices: arrayOf(detailedInvoiceShape.isRequired).isRequired,
  initialized: bool.isRequired,
  onInitialize: func.isRequired,
  onDeleteBookingEntry: func.isRequired,
  onDeleteInvoice: func.isRequired,
  onUpdateLatestTask: func.isRequired,
  onReloadBookingEntries: func.isRequired,
  loading: bool.isRequired,
  staticData: shape({
    products: arrayOf(productShape.isRequired).isRequired,
    campaign: campaignShape,
  }).isRequired,
  latestTask: taskShape,
  openInvoiceId: number,
};

BalanceModalContent.defaultProps = {
  latestTask: null,
  openInvoiceId: undefined,
};

export { BalanceModalContent };

const BalanceModalContentWithStaticData = withResolved({
  query: opp => {
    return Promise.all([
      api.getProducts(),
      opp.campaignId ? api.getCampaign({ id: opp.campaignId }) : null,
    ]).then(([products, campaign]) => ({ products, campaign }));
  },
  deriveQueryArgs: ({ opportunity }) => opportunity,
  as: 'staticData',
})(BalanceModalContent);

export default createModalToggle(
  'Invoicing',
  BalanceModalContentWithStaticData,
  { color: 'secondary' },
  { size: 'xl' },
);
